import { render, staticRenderFns } from "./battlereport.vue?vue&type=template&id=605e7b54&scoped=true"
import script from "./battlereport.vue?vue&type=script&lang=js"
export * from "./battlereport.vue?vue&type=script&lang=js"
import style0 from "./battlereport.vue?vue&type=style&index=0&id=605e7b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e7b54",
  null
  
)

export default component.exports